import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import HeaderLogo from "./_partials/HeaderLogo";
import DesktopNav from "./_partials/DesktopNav";
import MobileMenuButton from "./_partials/MobileMenuButton";
import MobileNavPanel from "./_partials/MobileNavPanel";
import { ACTIVATION_URL } from "@/lib/links";

const SCROLL_THRESHOLD = 40;
const SCROLL_TO_ANCHOR_DELAY_MS = 80;

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleWindowScroll = useCallback(() => {
    setScrolled(window.scrollY > SCROLL_THRESHOLD);
  }, []);

  useEffect(() => {
    handleWindowScroll();
    window.addEventListener("scroll", handleWindowScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleWindowScroll);
  }, [handleWindowScroll]);

  // Close mobile menu on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleAnchor = useCallback(
    (e, anchor) => {
      e.preventDefault();
      setOpen(false);
      if (location.pathname === "/") {
        const el = document.getElementById(anchor);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        navigate(`/#${anchor}`);
        setTimeout(() => {
          const el = document.getElementById(anchor);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, SCROLL_TO_ANCHOR_DELAY_MS);
      }
    },
    [location.pathname, navigate]
  );

  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = useCallback(() => setOpen((v) => !v), []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-background/90 border-b border-border/60 shadow-[0_1px_0_rgba(0,0,0,0.04)]"
          : "bg-background/40 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-6">
        <HeaderLogo onClick={closeMenu} />
        <DesktopNav onAnchorClick={handleAnchor} />
        <div className="flex items-center gap-2">
          <a href={ACTIVATION_URL} target="_blank" rel="noopener noreferrer" data-testid="header-start-analysis-cta"
            className="iw-btn-red hidden md:inline-flex items-center gap-2 px-5 py-2.5 text-[0.62rem] whitespace-nowrap">
            Start Your Analysis <span aria-hidden>→</span>
          </a>
          <MobileMenuButton open={open} onToggle={toggleMenu} />
        </div>
      </div>

      {open && <MobileNavPanel onAnchorClick={handleAnchor} />}
    </header>
  );
}
